module.exports = __webpack_public_path__ + "static/media/ricardo-perez-vest.2eb0f9c5.svg";